import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { InfoMessage } from '@eika/attention-message';
import { Checkbox } from '@eika/checkbox';
import { IconTypes } from '@eika/icon';
const TaxConfirmation = _ref => {
  let {
    onValueChange,
    showError,
    text
  } = _ref;
  const [checked, setChecked] = useState(false);
  const label = 'Jeg forplikter meg til å informere banken ved endringer';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(InfoMessage, {
    icon: IconTypes.BANK_24,
    header: "Skatterapportering",
    text: text.notifyBank
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Checkbox, {
    onValueChange: () => {
      setChecked(prevState => {
        const newState = !prevState;
        onValueChange(newState);
        return newState;
      });
    },
    checked: checked,
    label: label,
    error: showError && 'Du må godta vilkårene for å fortsette'
  }));
};
export default TaxConfirmation;